import { z } from 'zod';

export const SearchResultGroupZod = z.object({ groupId: z.number(), name: z.string(), parentGroupId: z.number() });
export type SearchResultGroup = z.infer<typeof SearchResultGroupZod>;
